import styles from './FooterWrapperV8.module.scss';

import clsx from 'clsx';
import React from 'react';

interface FooterWrapperV8Props {
  children?: React.ReactNode;
  className?: string;
}

export function FooterWrapperV8(props: FooterWrapperV8Props) {
  const className = clsx(styles.root, props.className);
  return <div className={className}>{props.children}</div>;
}
